import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";

function Header() {
  const { theme } = useTheme();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef();
  const buttonRef = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        isMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const linkClasses = (path) =>
    `text-lg block py-2 px-3 transition-all md:border-b-2 ${
      isActive(path)
        ? "border-slate-300 text-slate-200"
        : "border-transparent hover:border-slate-300 hover:text-slate-200"
    }`;

  return (
    <header
      className={`bg-gradient-to-r ${theme.gradient} p-4 text-white sticky top-0 z-50 shadow-md`}
    >
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/">
          <div className="flex items-center space-x-3">
            <img
              src="/images/logo.png"
              alt="Lisa Fuchsen Logo"
              className="h-12 w-12 rounded-full object-cover object-center"
            />
            <h1 className="text-2xl md:text-3xl font-bold tracking-wide hover:text-slate-200 transition-colors">
              Step Into Change
            </h1>
          </div>
        </Link>

        {/* Mobile Menu Button */}
        <button
          ref={buttonRef}
          className="md:hidden hover:bg-slate-600 rounded p-1 transition-colors"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {isMenuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>

        <nav
          ref={menuRef}
          className={`${
            isMenuOpen ? "block" : "hidden"
          } absolute top-full left-0 right-0 bg-slate-800 md:bg-transparent md:relative md:block`}
        >
          <ul className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-6 p-4 md:p-0">
            <li>
              <Link
                to="/"
                className={linkClasses("/")}
                onClick={() => setIsMenuOpen(false)}
              >
                Startseite
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className={linkClasses("/about")}
                onClick={() => setIsMenuOpen(false)}
              >
                Über mich
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className={linkClasses("/services")}
                onClick={() => setIsMenuOpen(false)}
              >
                Leistungen
              </Link>
            </li>
            <li>
              <Link
                to="/prices"
                className={linkClasses("/prices")}
                onClick={() => setIsMenuOpen(false)}
              >
                Kosten
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={linkClasses("/contact")}
                onClick={() => setIsMenuOpen(false)}
              >
                Kontakt
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
